
import { Form, Popconfirm, Table, Typography,Input,Button } from 'antd';
import { DeleteOutlined, EditOutlined, CloseOutlined, SaveOutlined } from "@ant-design/icons";
import React,{ useState } from 'react';

const { TextArea } = Input;

const EditableCell = ({
  editing,
  dataIndex, 
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'textarea' ? <TextArea rows={4}/> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const FaqTable = (props) => {
  const { faqList,editFAQ,deleteFAQ,label} = props;
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record._id === editingKey;

  const edit = (record) => {    
    form.setFieldsValue({
      question: '',
      answer: '',
      ...record,
    });
    setEditingKey(record._id);
  };
  const cancel = () => {
    setEditingKey('');
  };
  const save = async (key) => {
    try {
      const row = await form.validateFields();      
      const newData = [...faqList];      
      const index = newData.findIndex((item) => key === item._id);
      const updateRecord = row;
      updateRecord['_id'] = key;
      const saveData = await editFAQ(updateRecord);

      
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setEditingKey('');
      } else {
        newData.push(row);
        setEditingKey('');
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  const columns = [
    {
        title: 'Question',
        dataIndex: 'question',
        width: 'auto',
        editable: true,
        inputType: "input"
    },
    {
        title: 'Answer',
        dataIndex: 'answer',
        width: 'auto',
        editable: true,
        inputType: "textarea"
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span key={"div" + record._id}>
            <Button
              type="primary"
              size="small"              
              onClick={() => save(record._id)}
              style={{
                marginRight: 8,
              }}
            >
              <SaveOutlined />
            </Button>
            <Button size="small" type="danger" onClick={()=>cancel()}>
            <CloseOutlined />
            </Button>
          </span>
        ) : (
          <div key={"div" + record._id}>
            <Button type="primary" size="small" style={{ marginRight: 8,marginTop: 8 }} disabled={editingKey !== ''} onClick={() => edit(record)}>
            <EditOutlined />
            </Button>
            <Popconfirm
                title="Sure to delete?"
                onConfirm={() => deleteFAQ(record._id)}
                key={"del" + record._id}
            >
                <Button size="small" disabled={editingKey !== ""} style={{ marginRight: 8,marginTop: 8 }} type="danger"><DeleteOutlined /></Button>

            </Popconfirm>
          </div>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <Form form={form} component={false}>
      <div style={{ padding: "10px", textAlign: "center" }}><h3>{label}</h3></div>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={faqList}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          onChange: cancel,
        }}
      />
    </Form>
  );
};
export default FaqTable;